import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import LabelCollection from "../labels/LabelCollection";
import SpeciesLabel from "../labels/SpeciesLabel";

export default class AbstractShapeMode extends AbstractProvidedClass {
    sticky = {};

    get speciesIds() {
        return this.getTool('shapes').speciesId
            ? [this.getTool('shapes').speciesId]
            : [];
    }

    get labels() {
        const species = this.getTool('shapes').speciesId
            ? this.speciesCollection.get(this.getTool('shapes').speciesId)
            : null;
        const labels = species
            ? [new SpeciesLabel(this.provider, { id: species.id, keys: ['name', 'scientific_name'] })]
            : [];
        return new LabelCollection(this.provider, { labels: labels });
    }

    get layer() {
        return this.activeContextPanel.activeLayerId;
    }

    get addedDate() {
        return this.activeContextPanel.addedDate;
    }

    get removedDate() {
        return this.activeContextPanel.removedDate;
    }

    makeSticky(inputField) {
        this.sticky[inputField.attributeValue] = inputField;
        this.mouseMoved();
    }

    resetSticky() {
        Object.values(this.sticky).map((inputField) => inputField.inputElement.style('border', '1px solid #999999'));
        this.sticky = {};
    }

    get input() {
        return this.getTab('info').drawInput;
    }

    display(g) {
        throw new Error('Abstract method not implemented');
    }

    activate() { }

    deactivate() {
        this.reset();
    }

    pressMouseOnCanvas() { }

    makeShape() {
        throw new Error('Abstract method not implemented');
    }

    mouseMoved() { }

    doubleClickedOnCanvas() { }

    reset() {
        this.resetSticky();
        this.input.reset();
        this.input.hideDimensions();
    }

    getTips() { }

    pressKey(code) { }
}
